import HTMLRender from 'components/DetailRender/HTMLRender'
import CourseHero from 'designs/CourseHero'
import EOEvent from 'features/event/components/EOEvent'
import EventInfo from 'features/event/components/EventInfo'
import { useRouter } from 'next/router'
import { useEffect, useMemo } from 'react'
import { useSections } from 'shared/hooks/useSections'
import WithHeader from 'shared/layout/WithHeader'

import styles from './eventDetail.module.scss'

const EventDetail = () => {
  const router = useRouter()
  const courseId = useMemo(() => router.query.eventId, [router]) as string
  const { course, curriculum } = useSections(courseId)

  useEffect(() => {
    if (courseId === 'k-tech-college') {
      void router.push('https://likelion2.typeform.com/to/i3J0NqRV')
    }
  }, [courseId, router])

  if (courseId === 'eo-event') {
    return <EOEvent course={course} />
  }

  return (
    <WithHeader>
      <main style={{ minWidth: 360, marginBottom: 220 }}>
        <CourseHero
          title={course.title}
          subTitle={course.subtitle as string}
          heroImg={{
            sm: course.bannerBgImgS as string,
            md: course.bannerBgImgM as string,
            lg: course.bannerBgImg as string,
          }}
          textColor={course.bannerTextColor}
        />
        {/* 상세페이지 이미지 영역 */}
        <div className="mt-5 max-w-7xl lg:mt-6 lg:px-4 xl:mx-auto xl:px-6">
          <div className="lg:flex lg:flex-row-reverse lg:items-start">
            <aside
              className={`${styles.rightPanel} mb-6 h-auto lg:sticky lg:right-0 lg:mb-0 lg:shrink-0`}>
              <EventInfo course={course} curriculum={curriculum} />
            </aside>
            <div className="lg:mr-6">
              <hr className="h-3 w-full border-none bg-gray-100 lg:hidden" />
              <div className="px-4 pb-20 pt-4 lg:p-0">
                <HTMLRender html={course.description} />
              </div>
            </div>
          </div>
        </div>
      </main>
    </WithHeader>
  )
}

export default EventDetail
